import { Link, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DisclaimerWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
}));

export const Disclaimer = () => {
  const disclaimerMessage =
    "*Pricing displayed on this trade is indicative and may be subject to change due to available liquidity and timing. Read our ToB ";
  return (
    <DisclaimerWrapper>
      <Stack direction={"row"} spacing={1} ml={2}>
        <Typography
          style={{
            alignContent: "center",
            alignSelf: "center",
            fontSize: "14px",
          }}>
          {disclaimerMessage}
          <Link
            href={"https://www.calebandbrown.com/terms-of-business"}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: "bold" }}>
            here.
          </Link>
        </Typography>
      </Stack>
    </DisclaimerWrapper>
  );
};
